module.exports = __webpack_public_path__ + "static/img/partner-sy.a5c5ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-sy.png
// module id = iVwC
// module chunks = 34